export default "__VITE_ASSET__af6c845e__"